import * as types from '../../actions/actiontypes';

import {confidentialityTypes} from '../../util/uiconstants';
import initialState from '../initialstate';

//This reducer function handles user preferences.
export default function UserPreferencesReducer(state = initialState.userPreferences, action) {
	switch (action.type) {
		case types.GET_USER_PREFERENCES: {
			let userPreferences = action.response;
			userPreferences.userConfidentialityTypeId = 0;

			if (userPreferences?.permissions?.hasLowConfidentiality) {
				userPreferences.userConfidentialityTypeId = confidentialityTypes.LOW;
			}

			if (userPreferences?.permissions?.hasModerateConfidentiality) {
				userPreferences.userConfidentialityTypeId = confidentialityTypes.MODERATE;
			}

			if (userPreferences?.permissions?.hasHighConfidentiality) {
				userPreferences.userConfidentialityTypeId = confidentialityTypes.HIGH;
			}

			// if (userPreferences.permissions.hasConfidentialConfidentiality) {
			// 	userPreferences.userConfidentialityTypeId = confidentialityTypes.CONFIDENTIAL;
			// }

			userPreferences.isPreferencesLoaded = true;
			return userPreferences;
		}
		case types.SET_USER_PREFERENCES_FEDERATED_MODULE: {
			return {...state, ...action.payload};
		}
		// TODO: REMOVE
		case 'SET_USER_THEME': {
			let result = {...state};
			result.userPreferencesJson = action.isDark ? '{"theme":"dark"}' : '{"theme":"light"}';
			return result;
		}
		case types.SET_IS_PREFERENCES_LOADED: {
			let result = {...state};
			result.isPreferencesLoaded = true;
			return result;
		}
		default:
			return state;
	}
}
